export default {"src":"/_next/static/media/505.f4959fe9.svg","height":180,"width":180,"blurWidth":0,"blurHeight":0};